import React, { useState } from "react";
import { Link } from "react-router-dom";
import checkedSvg from "../../../../assets/checked.svg";
import { baseURL } from "../../../../misc/http";

export default function ListInstance({ organizer, handleSelectID }) {
  const [checked, setChecked] = useState("Semua");

  const option = [
    {
      label: "Semua Penyelenggara",
      value: "Semua",
    },
    {
      label: "PSrE Instansi",
      value: "PSrE Instansi",
    },
    {
      label: "PSrE Non-Instansi",
      value: "PSrE Non-Instansi",
    },
  ];

  return (
    <div>
      <div
        style={{
          height: "70px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0px 15px",
        }}
        className="container"
      >
        <p style={{ margin: 0, fontWeight: 700 }} className="h6-nunito">
          Daftar Penyelenggara Sertifikasi Elektronik Indonesia
        </p>
        <div>
          <Link
            style={{
              backgroundColor: "#1672BD",
              color: "white",
              border: "1px solid #1672BD",
            }}
            className="nav-link btn p-nunito btn-instance"
            to="/listpsrenew"
          >
            Lihat Semua
          </Link>
        </div>
      </div>
      <div className="psre-satu" style={{ backgroundColor: "#F9F9FA" }}>
        <div className="container">
          <div
            className="row"
            style={{
              height: "450px",
              padding: "48px 0px 0px 0px",
              overflow: "auto",
            }}
          >
            <div className="col-lg-4 container d-none d-lg-block">
              <div
                style={{
                  backgroundColor: "white",
                  borderRadius: "10px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "20px 30px 20px 30px",
                  }}
                >
                  <p
                    className="p-nunito"
                    style={{ margin: "0px", fontWeight: 700 }}
                  >
                    Pilih Kategori
                  </p>
                  <p
                    className="p-nunito"
                    style={{ margin: "0px", color: "#DADADA" }}
                  >
                    {organizer ? organizer.length : 0} daftar
                  </p>
                </div>
                <div style={{ height: "1px", backgroundColor: "#E5E5E5" }} />
                <div style={{ height: "18px" }} />
                {option.map((item) => (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      margin: "10px 0px 0px 40px",
                      cursor: "pointer",
                    }}
                    onClick={() => setChecked(item.value)}
                  >
                    <div style={{ marginRight: "10px" }}>
                      {checked === item.value ? (
                        <img
                          className="mb-0 btn-checked"
                          src={checkedSvg}
                          alt="checked"
                          style={{ height: "30px", objectFit: "contain" }}
                        />
                      ) : (
                        <div
                          style={{
                            height: "30px",
                            width: "30px",
                            backgroundColor: "white",
                            border: "1px solid #DADADA",
                            borderRadius: "10px",
                          }}
                          className="btn-checked"
                        />
                      )}
                    </div>
                    <p className="p-nunito" style={{ margin: 0 }}>
                      {item.label}
                    </p>
                  </div>
                ))}
                <div style={{ height: "28px" }} />
              </div>
            </div>
            <div
              className="col-lg-8 col-12"
              style={{ height: "402px", overflow: "auto" }}
            >
              {organizer
                .filter((item) => {
                  if (checked === "Semua") return item;
                  return item.type === checked;
                })
                .map((item) => (
                  <div
                    style={{
                      backgroundColor: "white",
                      borderRadius: 10,
                      marginBottom: 17,
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      padding: "30px 28px 30px 28px",
                    }}
                  >
                    <div
                      style={{
                        height: 27,
                        width: 100,
                        // backgroundColor: "red",
                        marginRight: "10px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      // to={`/organizer/${item._id}`}
                    >
                      <img
                        className="mb-0"
                        src={baseURL + item.logo}
                        alt="logo"
                        style={{ width: "100%", objectFit: "cover" }}
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flex: 1,
                        flexDirection: "column",
                        marginRight: "10px",
                      }}
                    >
                      <Link
                        style={{
                          display: "flex",
                          flex: 1,
                          flexDirection: "row",
                          alignItems: "center",
                          marginBottom: 5,
                        }}
                        // to={`/organizer/${item._id}`}
                      >
                        <p
                          className="p-nunito"
                          style={{
                            marginBottom: "0px",
                            fontWeight: 700,
                            color: "black",
                            marginRight: "10px",
                          }}
                        >
                          {item.companyName}
                        </p>
                      </Link>
                      <p
                        className="p-nunito"
                        style={{ marginBottom: "0px", color: "#1672BD" }}
                      >
                        {item.type}
                      </p>
                    </div>
                    <div>
                      <div
                        onClick={() => handleSelectID(item._id)}
                        style={{
                          backgroundColor: "white",
                          color: "black",
                          border: "1px solid black",
                        }}
                        className="nav-link btn p-nunito btn-instance"
                      >
                        Lihat Detail
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
